import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import styled from 'styled-components'

export const FormContainer = styled.form`
    .p-field {
        //margin: auto;
        margin-bottom: 1rem;
    }

    .long-p-field {
        flex-grow: 1;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
    }
`

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
`

export const Label = styled.label`
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
`

export const Information = styled.label`
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    color: #808080;
`

export const StyledInputField = styled(InputText)<{ readOnly?: boolean; hasError?: boolean }>`
    border-radius: 6px;
    padding: 15px;
    margin-top: 5px;
    font-size: 14px;
    transition:
        border-color 0.3s,
        box-shadow 0.3s,
        opacity 0.3s;

    &:focus,
    &:hover:enabled {
        border-color: #ba9d31;
        box-shadow: 0 0 3px #ba9d31;
        opacity: 0.9;
    }

    ${(props) =>
        props.readOnly &&
        `
        background-color: #f0f0f0;
    `}

    ${(props) =>
        props.hasError &&
        `
        border-color: red;
    `}
`

export const StyledTextareaField = styled(InputTextarea)<{ readOnly?: boolean; hasError?: boolean }>`
    border-radius: 6px;
    padding: 15px;
    margin-top: 5px;
    font-size: 14px;
    white-space: pre-wrap;
    transition:
        border-color 0.3s,
        box-shadow 0.3s,
        opacity 0.3s;

    &:focus,
    &:hover:enabled {
        border-color: #ba9d31;
        box-shadow: 0 0 3px #ba9d31;
        opacity: 0.9;
    }

    ${(props) =>
        props.readOnly &&
        `
        background-color: #f0f0f0; 
    `}

    ${(props) =>
        props.hasError &&
        `
        border-color: red;
    `}
`

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`

export const ButtonWrapper = styled.div`
    display: flex;
    width: min-content;
    gap: 10px;
`

export const SpinnerContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const ContributorsContainer = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 0px;
    justify-content: space-between;
`

export const FormFieldContainer = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
`
